<template>
  <div class="body-container pt-30">
    <div class="container-fluid">
      <router-link to="printPDF" class="btn btn-default float-right fw-600"
        >返回報表列印</router-link
      >
      <div class="font-16 mb-40">
        <span class="pdfTitle">321+1保藏圖</span>
        <span @click="instructions" class="text-orange btn">
          <i class="icon-attach i-20 textTop"></i>
          <u>使用說明</u>
        </span>
      </div>
      <div class="mb-40">
        <div>
          321+1保藏圖相關疑問請先閱讀上方【使用說明】，若仍對內容不了解可聯繫下方窗口
        </div>
        <div>聯絡電話： (02)2755-1399</div>
        <div>
          聯絡分機：
          <strong class="text-green"
            >商品一科 #2372~2377 或行銷企劃科 #2281、2269</strong
          >
        </div>
      </div>
      <!-- ------------------------------------------------可選報表------------------------------------------------ -->

      <div v-for="(item, index) in familyInfoList" :key="index" class="mb-50">
        <div class="text-black mb-15">
          <strong>
            {{ item.reportTitle }}
            <button
              type="button"
              style="vertical-align: middle"
              class="btn btn-default btn-sm baseLine"
              @click="
                item.familyResultFilter.forEach(
                  (element) => (element.check = true)
                )
              "
              v-show="!isSelectPdf"
            >
              選取所有成員
            </button>
            <button
              type="button"
              class="btn btn-default btn-sm baseLine"
              @click="
                item.familyResultFilter.forEach(
                  (element) => (element.check = false)
                )
              "
              v-show="isSelectPdf"
            >
              清空所有成員
            </button>
          </strong>
        </div>
        <div class="ml-27 row">
          <div
            class="col-2 pr-1 pl-1 mb-2"
            style="min-width: 150px"
            v-for="(itemI, indexI) in item.familyResultFilter"
            :key="indexI"
          >
            <div
              :class="` checkboxMv checkbox-inline ${
                familyInfoList[index].familyResultFilter[indexI]['check']
                  ? 'activeInput'
                  : 'nactiveInput'
              }`"
            >
              <input
                v-model="
                  familyInfoList[index].familyResultFilter[indexI]['check']
                "
                :value="itemI.csidno"
                type="checkbox"
                :id="`customer${index}-${indexI}`"
              />
              <label :for="`customer${index}-${indexI}`" class="ml-3">
                <span>{{ truncate(itemI.name, 12) }}</span>
                <!-- <span>{{ familyInfoList[index].familyResultFilter[indexI].check}}{{index}}{{indexI}}</span> -->
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- ------------------------------------------------可選報表------------------------------------------------ -->

      <!-- ----------------------------------------------報表顯示設定---------------------------------------------- -->
      <div class="mb-30">
        <div class="text-green mt-5 font-20">
          <strong>報表顯示設定</strong>
        </div>
        <div class="mt-3">
          1. 保戶為原住民時，是否顯示原住民姓名欄位顯示說明?
        </div>

        <div class="d-flex">
          <div class="radio radio-inline">
            <input type="radio" id="radioY" value="Y" v-model="isIndigenous" />
            <label for="radioY">是</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" id="radioN" value="N" v-model="isIndigenous" />
            <label for="radioN">否</label>
          </div>
        </div>
      </div>
      <!-- ----------------------------------------------報表顯示設定---------------------------------------------- -->
      <!-- ----------------------------------------------服務人員資訊---------------------------------------------- -->
      <div class="mb-60">
        <template>
          <div v-show="!serverEdit">
            <div
              class="text-green font-20 d-flex align-items-center"
              style="margin-bottom: 12px"
            >
              <span class="custModifyAgent">服務人員資訊</span>
              <button
                type="button"
                style="vertical-align: middle"
                class="btn btn-default btn-sm"
                @click="serverEdit = true"
              >
                修改
              </button>
            </div>
            <div
              class="text-black mt-2 mb-3 ml-2 d-flex align-items-center"
              style="height: 40px"
            >
              <span class="custAgentTitle">保險顧問</span>
              <span class="ml-3 custAgentContent">{{
                agentName ? agentName : "--"
              }}</span>
            </div>
            <div
              class="text-black ml-2 d-flex"
              :class="{ 'section-loading': loading_1 }"
            >
              <span class="custAgentTitle" style="line-height: 40px"
                >手機&emsp;&emsp;</span
              >
              <span>
                <span class="ml-3 custAgentContent" style="line-height: 40px"
                  >{{ agentMobile ? agentMobile : " " | mobileFormat }}
                </span>
                <div>&nbsp;</div>
              </span>
            </div>
          </div>
        </template>
        <template>
          <!-- ----------------------------------------------修改服務人員個人資訊(家庭)------------------------------- -->
          <EditAgentInfoFamily-Modal
            v-show="serverEdit"
            @close="serverEdit = false"
            @setAgentData="setAgentData"
          />
        </template>
      </div>
    </div>
    <!-- ----------------------------------------------列印PDF---------------------------------------------- -->
    <fixed-bottom>
      <template slot="@function">
        <form
          style="display: none"
          method="post"
          ref="form"
          target="_blank"
          :action="`${API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${fileNo}`"
        >
          <input
            type="submit"
            formtarget="_blank"
            :value="`${API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${fileNo}`"
          />
        </form>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-primary mr-0"
            v-show="!isIpad()"
            @click="showPDF(true)"
            type="button"
          >
            下載PDF
          </button>
          <button
            class="btn btn-primary mr-0"
            @click="showPDF(false)"
            type="button"
          >
            開啟PDF
          </button>
          <button
            :disabled="!$checkEdit(UserInfo)"
            type="button"
            class="btn btn-primary mr-0"
            @click="openEmail()"
          >
            發送EMAIL
          </button>
        </div>
      </template>
    </fixed-bottom>
    <!-- ----------------------------------------------列印pop-up---------------------------------------------- -->
    <mv-info :open="showOpenPdf" @close="printPDF()">
      <div class="text font-20" slot="content">
        <div style="color: red">
          <span style="font-weight: bold">優化後新系統的保障數值更為精確，</span
          >建議您提供新的報表給客戶參考。
        </div>
      </div>
    </mv-info>
    <!-- <hr style="border-width: 3px 0;" />
    <div class="d-flex justify-content-end">
      <button class="btn btn-primary mr-0" @click="printPDF" type="button">開啟PDF</button>
      <button
        type="button"
        class="btn btn-primary mr-0"
        @click="openEmail()"
      >發送EMAIL</button>
    </div> -->
    <!-- ----------------------------------------------列印PDF---------------------------------------------- -->
    <!-- ----------------------------------------------發送email---------------------------------------------- -->
    <SendEmail-Modal
      :open="sendEmailModalOpen"
      @close="panelClose('sendEmailModalOpen')"
      @doSendEmail="doSendEmail"
    />

    <!-- 打開遮罩 -->
    <mv-mask :open="mvMaskOpen" />
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { pdfPrintMixin } from "@/desktop/views/mv/pdfPrint/pdfPrintMixin";
import WarningModal from "@/desktop/components/WarningModal";
import NewGroup from "@/desktop/components/NewGroup";
import AddGroupModal from "@/desktop/components/AddGroupModal";
import SendEmailModal from "@/desktop/views/mv/components/SendEmailModal";
import EditAgentInfoFamilyModal from "@/desktop/views/mv/components/EditAgentInfoFamilyModal";

import mvMask from "@/desktop/views/mv/components/mvMask";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";
import HardwordMixins from "@/mixins/Hardword";
import mvInfo from "@/desktop/views/mv/components/mvInfo";
import {
  getAllFamily,
  getPDFFile,
  getPDFFileForMail,
  getAgntInfo,
  getPdfFileForReport,
} from "@/service";

import { mapGetters } from "vuex";
import { log } from "util";

export default {
  name: "321Img",
  mixins: [commonMixin, HardwordMixins, pdfPrintMixin],
  data() {
    return {
      serverEdit: false,
      dragging: false,
      enabled: true,
      //全選
      theadAll: false,
      //業務員ID
      agidno: this.$store.state.userInfo.id,
      //業務員名字
      agentName: "",
      //手機
      agentMobile: "",
      //過濾有勾選
      familyResultFilter: this.$store.state.familyResultFilter,
      //全部報表
      familyInfoList: [],
      //全部報表Drag
      familyInfoListDrag: [],
      //是否為原住民
      isIndigenous: "N",
      //是否列印封面
      isCover: "N",
      remoteDataMessage: "資料讀取中，請稍候...",
      sendEmailModalOpen: false,
      editAgentInfoFindInsModalOpen: false,
      loading_1: false,
      mvMaskOpen: false,
      //控制外層選取報表
      isSelectPdf: false,
      //PDF 彈窗
      showOpenPdf: false,
      isDownload: false,
      fileNo: "",
      API_BASEURL: "",
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    familyInfoList: {
      deep: true,
      handler(newValue, oldValue) {
        let selectCheck = 0;
        for (let i = 0; i < this.familyInfoList.length; i++) {
          let chk = 0;
          let isAll = this.familyInfoList[i].isAll;
          for (
            let j = 0;
            j < this.familyInfoList[i].familyResultFilter.length;
            j++
          ) {
            if (this.familyInfoList[i].familyResultFilter[j].check == true) {
              chk++;
              selectCheck++;
            }
          }
          if (
            (chk > 0 || isAll) &&
            !this.familyInfoListDragInclude(this.familyInfoList[i].reportTitle)
          ) {
            this.familyInfoListDrag.push(this.familyInfoList[i]);
            //整理
            this.sortDragItem();
          } else if (
            chk == 0 &&
            this.familyInfoListDragInclude(this.familyInfoList[i].reportTitle)
          ) {
            this.familyInfoListDragInclude(
              this.familyInfoList[i].reportTitle,
              "Y"
            );
            //整理
            this.sortDragItem();
          }
        }
        if (selectCheck > 0) {
          this.isSelectPdf = true;
        } else {
          this.isSelectPdf = false;
        }
      },
    },
  },
  components: {
    SendEmailModal,
    mvMask,
    FixedBottom,
    mvInfo,
    EditAgentInfoFamilyModal,
  },
  methods: {
    ...mapActions([
      "updateUserItems",
      "setPageLock",
      "updateFamilyResultFilter",
    ]),
    moment,
    instructions() {
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.isSendMail = false;
      // 若為webview開啟則不開新視窗
      let newWindow = this.isWebView() ? window : this.openNewWindow();
      getPdfFileForReport(this.agidno, "3211_20191211.pdf").then((result) => {
        if (result.byteLength <= 120) {
          if (!this.isWebView()) {
            newWindow.close();
          }
          this.panelClose("mvMaskOpen");
          setTimeout(() => alert("報表查無資料"));
          return;
        }
        let file = new Blob([result], { type: "application/pdf" });
        this.sendPdfDataToApp(file, "321+1保藏圖-使用說明");
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, "321+1保藏圖-使用說明.pdf");
        } else {
          newWindow.location = URL.createObjectURL(file);
        }
        this.panelClose("mvMaskOpen");
      });
    },
    detectIEEdge() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }

      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      var edge = ua.indexOf("Edge/");
      if (edge > 0) {
        // Edge => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
      }

      // other browser
      return false;
    },
    selectAll(selectType) {
      this.familyInfoList.forEach((element) => {
        element.theadAll = selectType;
        element.familyResultFilter.forEach(
          (elementI) => (elementI.check = selectType)
        );
      });
    },
    len(str) {
      return str.replace(/[^\x00-\xff]/g, "xx").length;
    },
    sub(str, n) {
      let l = 0;
      for (let i = 0; i < str.length; i++) {
        if (str[i].match(/[^\x00-\xff]/g)) {
          l += 2;
        } else {
          l++;
        }
        if (l >= n) {
          return str.substr(0, i + 1);
        }
      }
    },
    truncate(str, n) {
      if (str) {
        return this.len(str) > n ? this.sub(str, n) + "..." : str;
      } else {
        return "";
      }
    },
    showPDF(isDownload) {
      this.isDownload = isDownload;
      if (this.familyInfoListDrag && this.familyInfoListDrag.length > 0) {
        this.printPDF();
      } else {
        this.$toast.info({ title: "請確認列印對象" });
        return false;
      }
    },
    printPDF() {
      this.serverEdit = false;
      this.panelClose("showOpenPdf");
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.isSendMail = false;
      sendData.pdfNameForPrint = "321+1保藏圖.pdf";
      // 若為webview開啟則不開新視窗
      let newWindow = this.isWebView() ? window : this.openNewWindow();
      getPDFFile(this.agidno, sendData).then((result) => {
        let fileName =
          this.$store.state.userItems["name"] + "(3211)" + result.fileName;
        if (!(result.file && result.file.length > 0)) {
          if (!this.isWebView()) {
            newWindow.close();
          }
          this.panelClose("mvMaskOpen");
          setTimeout(() => alert("報表查無資料"));
          return;
        }
        this.fileNo = result.fileNo;
        setTimeout(() => {
          let file = new Blob([new Uint8Array(result.file)], {
            type: "application/pdf",
          });
          this.sendPdfDataToApp(file, fileName);
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, fileName);
          } else {
            if (this.isDownload) {
              this.chromeDonloadFile(file, fileName, newWindow);
            } else {
              if (this.isWebView()) {
                newWindow.location = URL.createObjectURL(file);
              } else {
                newWindow.location = `${this.API_BASEURL}/servlet/HttpDispatcher/DOWNLOAD_FILE_API2/download?fileNo=${this.fileNo}`;
              }
            }
          }
          this.panelClose("mvMaskOpen");
        }, 1000);
      });
    },
    openEmail() {
      if (this.familyInfoListDrag && this.familyInfoListDrag.length > 0) {
        this.panelOpen("sendEmailModalOpen");
      } else {
        this.$toast.info({ title: "請確認列印對象" });
      }
    },
    doSendEmail(form) {
      this.panelOpen("mvMaskOpen");
      let sendData = this.getSendData();
      sendData.subject = form.subject;
      sendData.senderName = form.senderName;
      sendData.sender = form.sender + "@cathaylife.com.tw";
      sendData.receiver = form.receiver;
      sendData.receivercc = form.receivercc;
      sendData.receiverbcc = form.receiverbcc;
      sendData.isSendMail = true;
      sendData.pdfNameForPrint = "321+1保藏圖.pdf";

      getPDFFileForMail(this.agidno, sendData).then((result) => {
        if (result.header && result.header.status === "200") {
          this.$toast.info({ title: "發送成功" });
        } else {
          this.$toast.info({ title: "發送失敗" });
        }
        this.panelClose("mvMaskOpen");
      });
    },
    getSendData() {
      let familyInfoList = [];

      this.familyInfoListDrag.forEach((dragItems) => {
        let familyInfoListObj = {};
        familyInfoListObj["reportType"] = dragItems.reportType;
        familyInfoListObj["cslist"] = [];
        familyInfoListObj["cslistName"] = [];
        dragItems.familyResultFilter.map((familyItems) => {
          if (familyItems.check) {
            familyInfoListObj.cslist.push(familyItems.csidno);
            familyInfoListObj.cslistName.push(familyItems.name);
            return familyItems.csidno;
          }
        });
        familyInfoList.push(familyInfoListObj);
      });

      let cslistAll = this.familyInfoList[0].familyResultFilter.map(
        (familyItems) => {
          return familyItems.csidno;
        }
      );
      let cslistAllName = this.familyInfoList[0].familyResultFilter.map(
        (familyItems) => {
          return familyItems.name;
        }
      );
      if (this.isCover === "Y") {
        familyInfoList.unshift({
          reportType: "C9",
          cslist: cslistAll,
          cslistName: cslistAllName,
        });
      }
      let sendData = {
        cslistAll: cslistAll,
        familyInfoList: familyInfoList,
        agidno: this.agidno,
        familyid: this.$store.state.userItems.csidno,
        familyName: this.$store.state.userItems.name,
        isIndigenous: this.isIndigenous,
        agentInfo: [
          {
            AGENTINFONAME: this.agentName,
            AGENTINFOMOBILE: this.agentMobile,
            REPORTSERIALNUMBER: `${this.generateSerial()}-${this.generateSerial()}`,
            AGIDNO: this.agidno,
          },
        ],
      };
      return sendData;
    },
    sortDragItem() {
      if (this.familyInfoListDrag.length > 0) {
        this.familyInfoListDrag.sort(function (a, b) {
          return a.reportType - b.reportType;
        });
      }
    },
    familyInfoListDragInclude(title, isSplice) {
      for (let i = 0; i < this.familyInfoListDrag.length; i++) {
        if (this.familyInfoListDrag[i].reportTitle == title) {
          if (isSplice === "Y") {
            this.familyInfoListDrag.splice(i, 1);
          }
          return true;
        }
      }
      return false;
    },
    checkMove: function (e) {
      // console.log("Future index: " + e.draggedContext.futureIndex);
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate).format("YYYY-MM-DD").split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    changeReportTitle(reportType) {
      if (reportType === "94") {
        return "321+1保藏圖";
      }
    },
    generateSerial() {
      var chars =
          "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
        serialLength = 10,
        randomSerial = "",
        i,
        randomNumber;

      for (i = 0; i < serialLength; i = i + 1) {
        randomNumber = Math.floor(Math.random() * chars.length);
        randomSerial += chars.substring(randomNumber, randomNumber + 1);
      }
      return randomSerial;
    },
    getAgentData() {
      this.loading_1 = true;
      getAgntInfo(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id
      ).then((result) => {
        if (result.header && result.header.status === "200") {
          this.agentName = result.data.agnt_name;
          this.agentMobile = result.data.mobile;
        }
        this.loading_1 = false;
      });
    },
    setAgentData(agentData) {
      this.agentName = agentData.agentNm;
      this.agentMobile = agentData.agentCellPhone;
    },
    initData() {
      this.dragging = false;
      this.enabled = true;
      //全選
      this.theadAll = false;
      //業務員ID
      this.agidno = this.$store.state.userInfo.id;
      //業務員名字
      this.agentName = "";
      //手機
      this.agentMobile = "";
      //過濾有勾選
      this.familyResultFilter = this.$store.state.familyResultFilter;
      //全部報表
      this.familyInfoList = [];
      //全部報表Drag
      this.familyInfoListDrag = [];
      //是否為原住民
      this.isIndigenous = "N";
      //是否列印封面
      this.isCover = "N";
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.sendEmailModalOpen = false;
      this.editAgentInfoFindInsModalOpen = false;
      this.loading_1 = false;
      this.mvMaskOpen = false;
      //控制外層選取報表
      this.isSelectPdf = false;
    },
    init() {
      for (let i = 0; i < 1; i++) {
        let filter = [];
        for (let i = 0; i < this.familyResultFilter.length; i++) {
          filter.push({
            csidno:
              this.familyResultFilter[i].csidno ||
              this.familyResultFilter[i].serNo,
            name: this.familyResultFilter[i].name,
            check: true,
          });
        }

        this.$set(this.familyInfoList, i, {
          isAll: false,
          familyResultFilter: filter,
          reportType: "94",
          reportTitle: this.changeReportTitle("94"),
        });
      }
      //取業務員電話
      this.getAgentData();

      // this.initGroupVue();

      // F5 重新整理方案

      // if(this.$store.state.userInfo.id === ''){
      //   setTimeout(() => {
      //     this.initGroupVue()
      //   }, this.$store.state.timeoutVal);
      // }else{
      //   this.initGroupVue()
      // }
    },
  },
  mounted() {
    //初始化過後更新刷新參數
    this.API_BASEURL = this.getUrl();
    this.$route.meta.reload = false;
    if (
      this.familyResultFilter &&
      this.familyResultFilter.length > 0 &&
      this.$store.state.userItems
    ) {
      localStorage.familyResultFilter = JSON.stringify(this.familyResultFilter);
      localStorage.UserItems = JSON.stringify(this.$store.state.userItems);
      this.init();
    } else {
      new Promise((resolve) => {
        this.updateFamilyResultFilter(
          JSON.parse(localStorage.familyResultFilter)
        );
        this.updateUserItems(JSON.parse(localStorage.UserItems));
        resolve();
      }).then(() => {
        this.familyResultFilter = this.$store.state.familyResultFilter;
        this.init();
      });
    }
  },
  activated() {
    //判斷是否需刷新頁面資料
    if (this.$route.meta.reload) {
      new Promise((resolve) => {
        this.initData();
        resolve();
      }).then(() => {
        this.init();
        this.$route.meta.reload = false;
      });
    } else {
      this.getAgentData();
    }
  },
  filters: {
    //手機格式化(加上'-')
    mobileFormat(srt) {
      if (!srt) {
        return "";
      } else {
        return (
          srt.substring(0, 4) +
          "-" +
          srt.substring(4, 7) +
          "-" +
          srt.substring(7)
        );
      }
    },
  },
};
</script>
<style scoped>
.body-container {
  margin-bottom: 150px;
}
.pdfTitle {
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}
.fit-image {
  width: 100%;
  object-fit: cover;
  /* height: 200px; only if you want fixed height */
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.activeInput {
  background-color: #fdeddc;
  border-radius: 6px;
}
.nactiveInput {
  background-color: rgba(234, 232, 232, 0.877);
  border-radius: 6px;
}
.pt-30 {
  padding-top: 30px;
}
.minHeight-120 {
  min-height: 120vh;
}
.verticalMiddle {
  vertical-align: middle;
}
.w-90 {
  width: 90px;
}
.w-148 {
  width: 148px;
}

.font-16 {
  font-size: 16px;
}
.font-20 {
  font-size: 20px;
}

.font-24 {
  font-size: 24px;
}

.pr-70 {
  padding-right: 70px;
}

.mb-10 {
  margin-bottom: 10px;
}
.mb-15 {
  margin-bottom: 15px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-40 {
  margin-bottom: 40px;
}
.mb-50 {
  margin-bottom: 50px;
}
.mb-60 {
  margin-bottom: 60px;
}

.ml-10 {
  margin-left: 10px;
}
.ml-14 {
  margin-left: 14px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-27 {
  margin-left: 27px;
}

.mr-14 {
  margin-right: 14px;
}
.mr-20 {
  margin-right: 20px;
}
.mb-90 {
  margin-bottom: 90px;
}
.baseLine {
  vertical-align: baseline !important;
}

.textTop {
  vertical-align: text-top !important;
}

.custModifyAgent {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}

.custAgentTitle {
  margin-right: 15px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align-last: right;
  color: #323a45;
}

.custAgentContent {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}
</style>